
    var riot = require('riot')
    riot.tag2('comment-feedback-modal', '<div name="modalBackground" class="modal-background modal-default" data-modal-background data-modal-close-trigger riot-style="z-index: 10000; height: {modalHeight}px" data-clickable-list-ignore-click onclick="{onClose}" if="{isOpen() === true}"> <div name="modal" class="modal" data-modal> <button class="modal-close" onclick="{onClose}"></button> <comment-feedback-modal-form name="formModal" payload="{initPayload}" validator="{opts.validator}" breakpoints="{opts.breakpoints}" if="{modalVisibleState.formModal}"> </comment-feedback-modal-form> <comment-feedback-modal-success name="successModal" if="{modalVisibleState.successModal}"> </comment-feedback-modal-success> <comment-feedback-modal-abort name="abortModal" if="{modalVisibleState.abortModal}"> </comment-feedback-modal-abort> <comment-feedback-modal-error name="errorModal" payload="{errorPayload}" if="{modalVisibleState.errorModal}"> </comment-feedback-modal-error> </div> </div>', '', '', function(opts) {
        var hasSentSuccess = false;
        var formMessageLength = 0;
        this.initPayload = {};
        this.modalVisibleState = {
            'formModal': false,
            'successModal': false,
            'abortModal': false,
            'errorModal': false
        };
        this.errorPayload = {};

        this.setVisibleModal = function (tagName, update) {
            for (var name in this.modalVisibleState) {
                if (this.modalVisibleState.hasOwnProperty(name)) {
                    this.modalVisibleState[name] = false;
                }
            }

            if (tagName) {
                this.modalVisibleState[tagName] = true;
            }

            if (update === true) {
                this.update();
            }
        }.bind(this);

        this.isOpen = function () {
            for (var name in this.modalVisibleState) {
                if (this.modalVisibleState.hasOwnProperty(name)) {
                    if (this.modalVisibleState[name] === true) {
                        return true;
                    }
                }
            }
            return false;
        }.bind(this);

        this.initialize = function (payload) {
            this.modalHeight = $(document).height();
            this.initPayload = payload;
            this.setVisibleModal('formModal', true);
            if (!this.modalBackground.style.opacity || this.modalBackground.style.opacity === '0') {
                this.fadeIn();
            }
            this.adjustMarginTop();
        }.bind(this);

        this.adjustMarginTop = function () {
            var scroll = $(document).scrollTop();
            var windowHeight = $(window).height();
            var modalHeight = $(this.modal).height();
            var marginTop = parseInt(scroll + (windowHeight / 2) - (modalHeight / 2), 10);
            this.modal.style.marginTop = ((marginTop < 5) ? 5 : marginTop)  + 'px';
        }.bind(this);

        this.fadeIn = function () {
            this.modalBackground.style.opacity = 1;
        }.bind(this);

        this.onClose = function (evt) {
            if (evt.target === evt.currentTarget) {
                this.closeModal();
            }
        }.bind(this);

        this.closeModal = function () {
            if (formMessageLength > 0 && this.modalVisibleState['formModal'] === true) {
                this.confirmClose();
                return;
            }

            this.modalBackground.style.opacity = 0;
            this.setVisibleModal(false);

            if (hasSentSuccess === true) {
                window.location.reload(true);
            }

            this.bus.trigger('ui:comment-feedback-modal:after-close');
        }.bind(this);

        this.onRetry = function () {
            this.setVisibleModal('formModal', true);
        }.bind(this);

        this.confirmClose = function () {
            this.setVisibleModal('abortModal', true);
        }.bind(this);

        this.onSentSuccess = function () {
            hasSentSuccess = true;
            this.setVisibleModal('successModal', true);
        }.bind(this);

        this.onFormEdit = function (payload) {
            formMessageLength = payload.msgLength;
        }.bind(this);

        this.onSentError = function (payload) {
            this.errorPayload = payload;
            this.setVisibleModal('errorModal', true);
        }.bind(this);

        this.on('mount', function () {
            this.bus.on('ui:comment-feedback-modal-error:on-close ui:comment-feedback-modal-form:on-close ui:comment-feedback-modal-abort:on-close ui:comment-feedback-modal-success:on-close', this.closeModal);
            this.bus.on('ui:comment-feedback-modal-abort:on-retry', this.onRetry);
            this.bus.on('ui:contact-modal:show-modal', this.initialize);
            this.bus.on('data:contact-service:message-sent-failed', this.onSentError);
            this.bus.on('data:contact-service:message-sent-success', this.onSentSuccess);
            this.bus.on('ui:comment-feedback-modal-form:on-edit', this.onFormEdit);
        }.bind(this));
});


    
  


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/comment-feedback/comment-feedback-modal.riot.html